import { drivewayForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * D2. Wniosek o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi gminnej — zarząd dróg (jednostka
 * organizacyjna gminy) — art. 29 ust. 1–5 ustawy o drogach publicznych; opłata 82 zł, zwolnienie dla budownictwa
 * mieszkaniowego. Ta sama procedura co B6, inny organ i część katalogu (builder: definitions/sharedRoads.ts). Brak wzoru
 * ogólnopolskiego; pola zweryfikowane z wnioskiem Gminy Nysa
 * (https://www.nysa.eu/resource/60629/1.Wniosek+o+zezwolenie+na+lokalizacj%25C4%2599+lub+przebudow%25C4%2599+zjazdu.pdf —
 * pobrany 2026-10-22: tak): rodzaj zjazdu (zwykły / techniczny / awaryjny), cele obsługi komunikacyjnej, rodzaj pojazdów
 * i natężenie ruchu, tytuł prawny; załączniki: mapa 1:500/1:1000, tytuł prawny, dowód opłaty 82 zł, WZ przy braku MPZP.
 */
const D2 = drivewayForm({
  code: "D2",
  title: "Wniosek do zarządu dróg o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi gminnej",
  description: "Zezwolenie zarządu dróg na budowę nowego albo przebudowę istniejącego zjazdu (wjazdu) z drogi gminnej.",
  organ: ROAD_ORGAN.municipalUnit,
  office: EEbiFormOffice.MunicipalUnit,
  road: "gminna",
});

export default D2;
